/**
 * Trial quota client — mirrors `app/api/v1/workspaces.py::QuotaOut`.
 *
 * The UI fetches this on workspace resolve and re-fetches after each Ask
 * Meridian round-trip so the banner stays current without a websocket.
 */

import { api } from "./api";

export type QuotaState = "ok" | "nudge" | "warning" | "blocked" | string;

export interface Quota {
  paid: boolean;
  expired: boolean;
  days_remaining: number;
  messages_used: number;
  messages_total: number;
  messages_remaining: number;
  state: QuotaState;
}

export function fetchWorkspaceQuota(workspaceId: string): Promise<Quota> {
  return api<Quota>(`/api/v1/workspaces/${workspaceId}/quota`);
}

/**
 * Engagement signal — drives the in-app sales prompt.
 *
 *  - `browsing`: still kicking the tyres. No prompt shown.
 *  - `engaged`: real but light use. No prompt yet, but counts toward
 *    showing one once the heavier thresholds tip into `hooked`.
 *  - `hooked`: clearly using it for real (multiple uploads + many
 *    questions). The frontend surfaces a contact chat-bubble unless
 *    the user has dismissed it.
 */
export type EngagementStatus = "browsing" | "engaged" | "hooked" | string;

export interface Engagement {
  status: EngagementStatus;
  uploads_count: number;
  messages_used: number;
  days_since_first_active: number;
  days_since_last_active: number | null;
}

export function fetchWorkspaceEngagement(
  workspaceId: string,
): Promise<Engagement> {
  return api<Engagement>(`/api/v1/workspaces/${workspaceId}/engagement`);
}
